import { render, staticRenderFns } from "./Reference.vue?vue&type=template&id=1f74b5b7&"
import script from "./Reference.vue?vue&type=script&lang=js&"
export * from "./Reference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports